<template>
  <div class="achievement-list" :class="{ 'locale-zh-CN': isZhLocale }">
    <div 
      v-for="(item, index) in items" 
      :key="item.id || index"
      class="achievement-item"
      @click="handleItemClick(item)"
    >
      <div class="item-image-wrapper">
        <img 
          :src="getImage(item.image)" 
          :alt="item.title" 
          class="item-image"
          @error="handleImageError"
        />
      </div>
      <div class="item-content">
        <h4 class="item-title">{{ item.title }}</h4>
        <div class="item-tags">
          <!-- <span class="tag-badge">{{ item.transferType || transferType }}</span>
          <span class="tag-divider">|</span> -->
          <span class="tag-item">{{ feeLabel }}<span class="tag-highlight">{{ item.price || feeValue }}</span></span>
        </div>
        <div class="item-info">
          <div class="info-row">
            <img src="~@/assets/img/gongxuzhongxin/location.png" alt="" class="info-icon" />
            <span class="info-text">{{ organizationLabel }}{{ item.organization }}</span>
          </div>
          <div class="info-row">
            <img src="~@/assets/img/gongxuzhongxin/location.png" alt="" class="info-icon" />
            <span class="info-text">{{ phoneLabel }}{{ item.phone }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getSafeImage, handleImgError } from '@/utils/imageFallback'
import { getText } from '@/utils/i18nText'
export default {
  name: 'AchievementList',
  props: {
    // 成果列表数据
    items: {
      type: Array,
      default: () => []
    },
    // 转化方式标签
    transferType: {
      type: String,
      default: () => getText('achievementList.transferType', '技术入股/创业孵化')
    },
    // 费用标签
    feeLabel: {
      type: String,
      default: () => getText('achievementList.feeLabel', '费用：')
    },
    // 费用值
    feeValue: {
      type: String,
      default: () => getText('achievementList.feeValue', '双方协商')
    },
    // 所属单位标签
    organizationLabel: {
      type: String,
      default: () => getText('achievementList.organizationLabel', '所属单位：')
    },
    // 联系电话标签
    phoneLabel: {
      type: String,
      default: () => getText('achievementList.phoneLabel', '联系电话：')
    }
  },
  methods: {
    handleItemClick(item) {
      this.$emit('item-click', item)
    },
    
    handleImageError(event) {
      handleImgError(event)
    },

    getImage(src) {
      return getSafeImage(src)
    }
  }
}
</script>

<style lang="scss" scoped>
.achievement-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  
  .achievement-item {
    background: #FFFFFF;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: row;
    height: 100%;
    
    &:hover {
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }
    
    .item-image-wrapper {
      width: 200px;
      min-width: 200px;
      height: 140px;
      overflow: hidden;
      flex-shrink: 0;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .item-image {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        object-fit: contain;
        object-position: center;
        transition: transform 0.3s;
      }
    }
    
    &:hover .item-image {
      transform: scale(1.05);
    }
    
    .item-content {
      flex: 1;
      padding: 16px 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      
      .item-title {
        font-family: Source Han Sans CN;
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        line-height: 24px;
        margin: 0 0 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      
      .item-tags {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 12px;
        font-family: Source Han Sans CN;
        font-size: 12px;
        line-height: 22px;
        
        .tag-badge {
          display: inline-block;
          padding: 2px 8px;
          background: #F8F8F8;
          color: #666666;
          border-radius: 2px;
          font-size: 12px;
        }
        
        .tag-item {
          color: #666666;
        }
        
        .tag-divider {
          color: #DDDDDD;
        }
        
        .tag-highlight {
          color: #FF0000;
          font-weight: 500;
        }
      }
      
      .item-info {
        margin-top: auto;
        .info-row {
          display: flex;
          align-items: center;
          gap: 6px;
          margin-bottom: 8px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 22px;
          
          .info-icon {
            width: 12px;
            height: 12px;
            flex-shrink: 0;
            opacity: 0.8;
          }
          
          .info-text {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            flex: 1;
          }
          
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
